<nb-card>
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <h5>Vendor Mapping</h5>
    <button nbButton status="primary" (click)="saveVendorMappings()">
      Save Mappings
    </button>
  </nb-card-header>

  <nb-card-body>
    <!-- Filters -->
    <form [formGroup]="filterForm" class="row mb-4">
      <div class="col-md-4">
        <label class="label">Customer Part No</label>
        <input nbInput fullWidth formControlName="customerPartNo" placeholder="Filter by Customer Part No">
      </div>
      <div class="col-md-4">
        <label class="label">Vendor Name</label>
        <input nbInput fullWidth formControlName="vendorName" placeholder="Filter by Vendor Name">
      </div>
      <div class="col-md-4">
        <label class="label">Internal Part No</label>
        <input nbInput fullWidth formControlName="internalPartNo" placeholder="Filter by Internal Part No">
      </div>
    </form>

    <!-- Mappings Table -->
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Customer Part No</th>
            <th>Internal Part No</th>
            <th>Description</th>
            <th>Specification</th>
            <th>Manufacturer</th>
            <th>UOM</th>
            <th>Project Qty</th>
            <th>Vendors</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mapping of partVendorMappings">
            <td>{{ mapping.customerPartNo }}</td>
            <td>{{ mapping.internalPartNo }}</td>
            <td>{{ mapping.description }}</td>
            <td>{{ mapping.specification }}</td>
            <td>{{ mapping.manufacturer }}</td>
            <td>{{ mapping.uom }}</td>
            <td>{{ mapping.projectQty }}</td>
            <td>
              <nb-card class="vendor-card">
                <nb-card-body>
                  <div class="vendor-list">
                    <div class="vendor-header d-flex justify-content-between mb-2">
                      <span>Select Vendors</span>
                      <div>
                        <button nbButton ghost size="small" (click)="toggleAllVendors(mapping, true)">Select All</button>
                        <button nbButton ghost size="small" (click)="toggleAllVendors(mapping, false)">Deselect All</button>
                      </div>
                    </div>
                    <div *ngFor="let vendor of mapping.vendors" class="vendor-item">
                      <nb-checkbox [(ngModel)]="vendor.isSelected">
                        {{ vendor.name }}
                      </nb-checkbox>
                      <div class="vendor-details" *ngIf="vendor.isSelected">
                        <small>
                          Target Price: {{ vendor.targetPrice }} {{ vendor.currency }} |
                          Lead Time: {{ vendor.leadTime }} weeks
                        </small>
                      </div>
                    </div>
                  </div>
                </nb-card-body>
              </nb-card>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </nb-card-body>
</nb-card>
